/* MASAL Collection
   File: assets/masal-collection.js
*/

(() => {
  const initCollection = (root) => {
    if (!root || root.dataset.masalCollectionReady === 'true') return;
    root.dataset.masalCollectionReady = 'true';

    const panel = root.querySelector('[data-masal-filter-panel]');
    const overlay = root.querySelector('[data-masal-filter-overlay]');
    const openButton = root.querySelector('[data-masal-filter-open]');
    const closeButton = root.querySelector('[data-masal-filter-close]');

    const openFilters = () => {
      if (!panel || !overlay) return;
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.classList.add('masal-filter-lock');
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
    };

    const closeFilters = () => {
      if (!panel || !overlay) return;
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('masal-filter-lock');
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
    };

    openButton?.addEventListener('click', openFilters);
    closeButton?.addEventListener('click', closeFilters);
    overlay?.addEventListener('click', closeFilters);

    root.querySelectorAll('[data-masal-auto-submit]').forEach((control) => {
      control.addEventListener('change', () => {
        const form = control.closest('form');
        if (form) form.submit();
      });
    });

    root.querySelectorAll('.masal-product-card').forEach((card) => {
      if (card.querySelector('.masal-product-card__image--secondary')) {
        card.classList.add('has-secondary-image');
      }
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeFilters();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-masal-collection-main]').forEach(initCollection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();